const LEGEND_ITEMS = [
  { type: 'SUPPORT', label: 'Support / Leistung', color: 'bg-blue-400' },
  { type: 'APPOINTMENT_FIX', label: 'Termin (Fix)', color: 'bg-brand-400' },
  { type: 'APPOINTMENT_PROPOSAL', label: 'Terminvorschlag', color: 'bg-purple-400' },
  { type: 'APPOINTMENT_PRIVATE', label: 'Privat', color: 'bg-gray-400' },
  { type: 'VACATION', label: 'Urlaub', color: 'bg-green-500' },
  { type: 'ILLNESS', label: 'Krank', color: 'bg-red-500' },
  { type: 'ABSENCE', label: 'Abwesenheit', color: 'bg-orange-400' },
  { type: 'STAND_BY', label: 'Bereitschaft', color: 'bg-yellow-400' },
  { type: 'OVERTIME', label: 'Überstunden', color: 'bg-teal-400' },
  { type: 'CUSTOM', label: 'Sonstiges', color: 'bg-indigo-400' },
  { type: 'AUSSENEINSATZ', label: 'Außeneinsatz', color: 'bg-amber-500' },
]

export function DispositionCalendarLegend() {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-gray-600 pt-2 border-t border-gray-100 mt-2">
      {LEGEND_ITEMS.map((item) => (
        <span key={item.type} className="flex items-center gap-1.5">
          <span className={`inline-block w-2.5 h-2.5 rounded-sm ${item.color}`} />
          {item.label}
        </span>
      ))}
    </div>
  )
}
